var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4502 6.24451L3.91797 13.9633C3.85589 14.034 3.76545 14.0697 3.67578 14.0697H1.5791C1.38604 14.0696 1.23438 13.9132 1.23438 13.7152V11.5648C1.23439 11.4658 1.26893 11.3807 1.33789 11.3099L8.86328 3.59216L11.4502 6.24451ZM11.3496 1.33337C11.532 1.33339 11.7071 1.40795 11.8359 1.54041L13.4502 3.19568C13.7191 3.4716 13.7192 3.91786 13.4502 4.19373L12.1875 5.48767L9.60059 2.83533L10.8633 1.54041C10.9922 1.40793 11.1672 1.33337 11.3496 1.33337Z",
    fill: "#AAAAB9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 13.0908,
    width: 8.75895,
    height: 0.875895,
    rx: 0.437947,
    fill: "#AAAAB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6cadc0e8.svg";
export { ForwardRef as ReactComponent };